import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router';
import { Spin } from 'antd';

const MainPage = lazy(() => import('./main-page.tsx'));
const ApiQueryExamplePage = lazy(() => import('./api-query-example-page.tsx'));

export const customerRelationshipManagementRoutes: RouteObject = {
  path: 'customer-relationship-management',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spin />}>
          <MainPage />
        </Suspense>
      ),
    },
    {
      path: 'api-example',
      element: (
        <Suspense fallback={<Spin />}>
          <ApiQueryExamplePage />
        </Suspense>
      ),
    },
  ],
};
